import { createContext } from "react"
import React from "react"
import { CoresAplicativoInicial } from "../models/coresAplicativoModel"
import type { CoresAplicativoModel } from "../models/coresAplicativoModel"
import type { CoresAplicativoActionModel } from "./coresAplicativoActions"

type CoresAplicativoContextProps = {
    cores: CoresAplicativoModel
    dispatch: React.Dispatch<CoresAplicativoActionModel>
    salvar: () => Promise<void>
    carregando: boolean
    erroCarregamento: string | null
}

const initialContextValue: CoresAplicativoContextProps = {
    cores: CoresAplicativoInicial,
    dispatch: () => {},
    salvar: async () => {},
    carregando: false,
    erroCarregamento: null,
}

export const CoresAplicativoContext =
    createContext<CoresAplicativoContextProps>(initialContextValue)
